module.exports = __webpack_public_path__ + "img/chart3.5443f279.png";